var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button message-submit-button",class:{
    'is-loading': _vm.loading,
    'has-text-info is-borderless': !_vm.label,
    'is-success': _vm.label
  },attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_c('b-icon',{attrs:{"icon":"paper-plane"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }